// extracted by mini-css-extract-plugin
module.exports = {"refer":"Referral_refer__y7hJO","refer_modal":"Referral_refer_modal__8S5aK"};